<template><!-- VIEW: "Schedules" -->
  <v-container class='pt-8'>

    <v-menu :value="contextMenu.item" offset-y absolute :position-x="contextMenu.x" :position-y="contextMenu.y" >
      <v-list dense>
        <v-list-item link @click="openNewTab(contextMenu.item)"><v-icon class="mr-4 primary--text">mdi-open-in-new</v-icon>Open in new tab</v-list-item>
      </v-list>
    </v-menu>

    <v-card class='rounded-lg'>

      <v-card-title class='primary white--text'>
        <v-select
          placeholder="Schedule"
          :items="schedules" item-value="xid" item-text="title" return-object
          v-model="schedule" clearable
          class='mr-4' style='max-width:400px;' outlined rounded dense dark hide-details 
        />
        <v-spacer />
        <v-btn small icon dark :disabled="!schedule" @click="() => { this.page = 1; refreshTasks(); }" class="mx-1"><v-icon>mdi-refresh</v-icon></v-btn>
        <v-btn small icon dark @click="() => { this.$refs['scheduleList'].open(); }" class="mx-1"><v-icon>mdi-chart-timeline</v-icon></v-btn>
        <v-btn small icon dark @click="print" class="mx-1"><v-icon>mdi-printer</v-icon></v-btn>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols=12 class='pb-0'>

          </v-col>
          <v-col cols=12 class='py-0'>
            <v-data-table
              :loading='loading'
              dense hide-default-footer
              :items-per-page="-1"
              class='taskTable'
              :items='tasks'
              item-key='xid'
              :headers='headers'
              @click:row='clickJob'
              :options.sync='options'
              :custom-sort="items=>items"
              @contextmenu:row="rightClickJob"
            >
              <template v-slot:item.jobPromised="{item}">
                <v-tooltip v-if='item.jobPromised' bottom>
                  <template v-slot:activator='{on,attrs}'>
                    <span v-on='on' v-bind='attrs'>{{moment(item.jobPromised).format('MMM D, Y')}}</span>
                  </template>
                  <span class='font-italic text-caption'>{{moment(item.jobPromised).from()}}</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols=12 class='' style='' v-if="schedule">
            <v-pagination v-model="page" :length="paginate_pages" :total-visible='15' @input='onPaginate' />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <ScheduleList ref="scheduleList" @done="schedulesUpdated" />

  </v-container>
</template>

<style lang="scss">
.taskTable{
  tbody td:hover{ cursor: pointer; }
}
.v-main{ overflow-y: auto; }
</style>


<script>
import { mapGetters,  mapActions } from 'vuex';
import PrintJS from 'print-js';
import Moment from 'moment';
import ScheduleList from '@/components/Schedule/ScheduleList'

export default {
  name: 'Schedule',
  components: {
    ScheduleList
  },
  props: {
    stageId: { type: String, required: false, default: null },
  },
  data(){ return {
    loading: false,
    schedules: [],
    schedule: null,
    tasks: [],
    closed: false,
    paginate_total: 0,
    paginate_pages: 0,
    page: 1,
    filter: '',
    filterType: ["customer", "address"],
    options: null,
    contextMenu: {
      item: null,
      x: null,
      y: null,
    }
  }},
  computed:{
    ...mapGetters("UI", ["JOB_STAGES"]),
    stage(){ return this.JOB_STAGES.find(s => s.xid == this.stageId) },
    headers(){
      let headers = [
        { text: "Job", value: 'jobNumber', sortable: false, },
        { text: "Task", value: 'type.title', sortable: false, },
        { text: "Description", value: 'description', sortable: false, },
        { text: "Customer", value: 'custName', sortable: false, },
        { text: "Promised", value: 'jobPromised', sortable: false, },
      ];
      return headers;
    },
    sortBy(){ return this.options?.sortBy[0] ?? null; },
    sortDesc(){ return this.options?.sortDesc[0] ?? false; },
  },
  watch: {
    $route: { handler(){ this.SET_TITLE(this.schedule ? this.schedule.title : "Schedules"); }, immediate: true },
    schedule(){
      this.page = 1;
      this.refreshTasks();
      this.SET_TITLE(this.schedule ? this.schedule.title : "Schedules");
    },
    schedules(){
      if(!this.schedules.map(s=>s.xid).includes(this.schedule?.xid))
        this.schedule = null;
    },
  },
  methods: {
    ...mapActions("UI", ["SET_TITLE", "CONFIRM", "NAVIGATE"]),
    ...mapActions("API", ["API"]),

    moment(m){ return new Moment(m); },

    refreshTasks(){
      this.tasks = [];
      if(!this.schedule) return;
      this.loading = true;
      this.API({ method: 'GET', endpoint: `schedules/${this.schedule.xid}/tasks2?page=${this.page}` })
      .then(results => {
        this.tasks = results.data;
        this.paginate_total = results.total;
        this.paginate_pages = results.last_page;
      })
      .finally(() => { this.loading = false; });
    },

    onPaginate(){
      this.refreshTasks();
      this.$parent.$el.scrollTop = 0;
    },

    clickJob(task){
      window.open(`jobs/all/${task.jobId}`, '_blank');
    },

    rightClickJob(e, row){
      let job = row.item;
      this.contextMenu = { ...this.contextMenu,
        item: job,
        x: e.clientX, y: e.clientY
      };
      e.preventDefault();
    },

    openNewTab(task){
      window.open(`jobs/all/${task.jobId}`, '_blank');
    },

    print(){
      if(this.schedule){
        this.API({ endpoint: `schedules/${this.schedule.xid}/print` })
        .then(printable => {
          PrintJS({ printable, type: 'pdf', base64: true });
        });
      }
      else{
        let data = { schedules: this.schedules.map(s=>s.xid), waiting: false };
        this.API({ method: "POST", endpoint: `scheduling/print`, data })
        .then(printable => {
          PrintJS({ printable, type: 'pdf', base64: true });
        });
      }
    },

    refreshSchedules(){
      this.loading = true;
      return this.API({ endpoint: 'schedules' })
      .then(data => {
        this.schedules = data;
      })
      .finally(() => { this.loading = false; });
    },

    schedulesUpdated(){
      this.refreshSchedules()
      .then(() => {
        this.page = 1;
        this.refreshTasks();
      });
    }

  },
  mounted(){
    this.refreshSchedules()
    .then(this.refreshTasks)
  }
}
</script>
